import Experience from '../Experience';
import * as THREE from 'three';
import gsap from 'gsap';
import { TransformControls } from 'three/examples/jsm/controls/TransformControls.js'
import { useBVH } from '@react-three/drei';

export default class LongCVManager 
{
    constructor(pWorkdenSceneRef)
    {
        this.experienceRef = new Experience();
        this.threeJSsceneRef = this.experienceRef.threeJSscene;
        this.workDenScene = pWorkdenSceneRef;
        this.cameraRef = this.experienceRef.camera;

        // Bind the method so "this" inside onPointerMove refers to the class instance
        this.onPointerMove = this.onPointerMove.bind(this);
        window.addEventListener('pointermove', this.onPointerMove, false);
        this.mouse = new THREE.Vector2();

        this.isCVFocussed = false;        
        this.cvDefaultTransformHolder = new THREE.Object3D();        
        this.cvDefaultTransformHolder.position.copy(this.workDenScene.resume.position);
        this.cvDefaultTransformHolder.quaternion.copy(this.workDenScene.resume.quaternion);

        // For Debug purposes
        // this.abridgedCvDebugTransformControls = new TransformControls(this.cameraRef.cameraInstance, this.experienceRef.canvas);
        // this.abridgedCvDebugTransformControls.attach(this.workDenScene.resume);
        // this.abridgedCvDebugTransformControls.setMode("translate");
        // this.abridgedCvDebugTransformControls.setSpace("local");
        // this.threeJSsceneRef.add(this.abridgedCvDebugTransformControls);
    }

    moveCVtoCamera()
    {
        if (this.cameraRef == null)
        {
            this.cameraRef = this.experienceRef.camera;
        }

        this.cameraRef.cameraState = 'resumeLongFocussed';
        this.cameraRef.orbitControls.enableDamping = false;
        this.cameraRef.orbitControls.update();
        this.cameraRef.orbitControls.enabled = false;
       
        const cameraForwardDirectionVector = new THREE.Vector3();
        this.cameraRef.cameraInstance.getWorldDirection(cameraForwardDirectionVector); // Get the camera's forward direction
        const targetPositionVector = 
        new THREE.Vector3().copy(this.cameraRef.cameraInstance.position).add(cameraForwardDirectionVector.multiplyScalar(1050));

        // Convert world position to local space
        const parent = this.workDenScene.resume.parent; // Get parent object
        if (parent) {
            parent.worldToLocal(targetPositionVector);
        }

        gsap.to(
            this.workDenScene.resume.position,
            {
                duration : 0.25,
                ease: "sine.inOut",
                x: targetPositionVector.x,
                y: targetPositionVector.y,
                z: targetPositionVector.z,
                onComplete: () => {
                    this.workDenScene.resume.lookAt(this.cameraRef.cameraInstance.position);
                    // Apply an extra rotation if the model is misaligned
                    this.workDenScene.resume.rotateX(Math.PI/2); // Adjust this value if needed
                    this.workDenScene.resume.updateMatrixWorld(true);

                    this.tiltQuat = new THREE.Quaternion();
                    this.baseQuat = this.workDenScene.resume.quaternion.clone(); // Save original rotation
                    this.isCVFocussed = true;                 
                }
            }            
        );
    }

    onPointerMove(event)
    {
        // Convert mouse position to normalized device coordinates
        this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

        //console.log("Pointer Moved");

        if (this.isCVFocussed)
        {
            // Tilt angles
            const tiltX = this.mouse.y * 0.1; // forward/back tilt
            const tiltZ = this.mouse.x * 0.1; // left/right tilt

            // Create a quaternion from local Euler tilt (X and Z axes)
            this.tiltQuat.setFromEuler(new THREE.Euler(tiltX, 0, tiltZ)); // Y is untouched           

            // Combine with original/base rotation (local space)
            this.workDenScene.resume.quaternion.copy(this.baseQuat).multiply(this.tiltQuat);
        }
    }

    moveCVtoDefaultPosition()
    {
        this.isCVFocussed = false;

        gsap.to(
            this.workDenScene.resume.position,
            {
                duration : 0.25,
                ease: "sine.inOut",
                x: this.cvDefaultTransformHolder.position.x,
                y: this.cvDefaultTransformHolder.position.y,
                z: this.cvDefaultTransformHolder.position.z,
                onComplete: () => {
                    this.cameraRef.cameraState = 'default';
                    this.cameraRef.orbitControls.enableDamping = true;
                    this.cameraRef.orbitControls.enabled = true;
                }
            }            
        );

        gsap.to(
            this.workDenScene.resume.rotation,
            {
                duration : 0.25,
                ease: "sine.inOut",
                x: this.cvDefaultTransformHolder.rotation.x,
                y: this.cvDefaultTransformHolder.rotation.y,
                z: this.cvDefaultTransformHolder.rotation.z
            }
        );

    }

}